
import { TableCostos } from "@/components/dashboard/TableCostos";
import { ChartCostosPorServicio } from "@/components/dashboard/ChartCostosPorServicio";
import { CreateCostForm } from "@/components/costs/CreateCostForm";

const Costos = () => {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h1 className="text-2xl font-bold tracking-tight">Costos</h1>
      </div>
      
      <div className="grid gap-4 md:grid-cols-6">
        <div className="col-span-2">
          <CreateCostForm />
        </div>
        <div className="col-span-4">
          <ChartCostosPorServicio />
        </div>
      </div>

      <div className="mt-4">
        <TableCostos />
      </div>
    </div>
  );
};

export default Costos;
